__turbopack_context__.v({
  "disabledItem": "CreationButton-module__EtVHGq__disabledItem",
  "iconButtonWrapper": "CreationButton-module__EtVHGq__iconButtonWrapper",
  "menu": "CreationButton-module__EtVHGq__menu",
  "menuText": "CreationButton-module__EtVHGq__menuText",
  "regularButtonWrapper": "CreationButton-module__EtVHGq__regularButtonWrapper",
  "root": "CreationButton-module__EtVHGq__root",
});
